import { AiFillProject } from 'react-icons/ai'
import { LuLayoutDashboard } from 'react-icons/lu'
import { FaTruckFast } from 'react-icons/fa6'
import { GrContact, GrDriveCage } from 'react-icons/gr'
import { BiSolidShoppingBags } from 'react-icons/bi'
import { VscServerProcess } from 'react-icons/vsc'
import { FaTruck } from 'react-icons/fa'
import { IoBagCheck } from 'react-icons/io5'
import { MdOutlineFileUpload } from 'react-icons/md'
import { FiShoppingBag } from 'react-icons/fi'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                url: '/user',
                text: 'Dashboard',
                permission: 'dashboard',
                icon: <LuLayoutDashboard />,
            },
            {
                active: ['/user/collector-collection-points'],
                url: '/user/collector-collection-points',
                text: 'Linked Collectors',
                permission: 'collector_collection_points',
                icon: <AiFillProject />,
            },
            {
                active: ['/user/projects'],
                url: '/user/projects',
                text: 'Projects',
                permission: 'projects',
                icon: <AiFillProject />,
            },
            {
                active: ['/user/waste-drops'],
                url: '/user/waste-drops',
                text: 'Waste Bag Drops ',
                permission: 'waste_drops',
                icon: <FaTruckFast />,
            },

            {
                active: ['/user/bulka-bags'],
                url: '/user/bulka-bags',
                text: 'Bulka Bag Bin',
                permission: 'bulko_bags',
                icon: <BiSolidShoppingBags />,
            },
            {
                active: ['/user/pickups'],
                url: '/user/pickups',
                text: 'Shipments',
                permission: 'pickup.index',
                icon: <FaTruck />,
            },
            {
                active: ['/user/batches'],
                url: '/user/batches',
                text: 'Batches',
                permission: 'batchs',
                icon: <VscServerProcess />,
            },
            {
                active: ['/user/collector-bag-requests'],
                url: '/user/collector-bag-requests',
                text: 'Bags Requested by Collector',
                permission: 'collector_bag_requests',
                icon: <FiShoppingBag />,
            },
            {
                active: ['/user/bag-requests'],
                url: '/user/bag-requests',
                text: 'Request Bags',
                permission: 'bag_requests',
                icon: <IoBagCheck />,
            },
            {
                active: ['/user/cages'],
                url: '/user/cages',
                text: 'ResiLoop Box',
                permission: 'cages',
                icon: <GrDriveCage />,
            },
            {
                active: ['/user/file-uploads'],
                // url: '/user/file-uploads',
                url: 'https://www.resiloop.org.au/collectors-resource-hub.html',
                text: 'Resources',
                permission: 'file_uploads',
                icon: <MdOutlineFileUpload />,
            },
            {
                active: ['/user/contacts'],
                url: '/user/contacts',
                text: 'Messages',
                permission: 'contacts',
                icon: <GrContact />,
            },
        ],
    },
]

export default appRoutes
